module.exports = __webpack_public_path__ + "static/industri-56bebfca663d0f4495eff01665f5a3a7.png";